import { v4 as uuid } from 'uuid';

const BULK_SEARCH_TYPE = 'bulk';
const SINGLE_SEARCH_TYPE = 'single';

export function mapOrganization(organization) {
  return {
    name: organization.name,
    domain: organization.web,
    position: organization.position,
    time: organization.time,
    isCurrentJob: organization.is_current_job === 'YES',
    companyLid: organization.company_lid,
    ...(organization.locality ? { locality: organization.locality } : {}),
  };
}

export function mapCurrentPosition(currentPosition) {
  return {
    name: currentPosition.companyName,
    position: currentPosition.title,
    isCurrentJob: currentPosition.current,
    companyLid: currentPosition.company_lid,
  };
}

export function mapSingleSearchData(searchData, isPluginOpen) {
  const contactId = uuid();

  return {
    metadata: {
      searchType: SINGLE_SEARCH_TYPE,
      requestId: searchData.request_id,
      parserType: searchData.metadata.parserType,
      isUnifiedParser: searchData.metadata.isUnifiedParser,
      isUnifiedParserEnabled: searchData.metadata.isUnifiedParserEnabled,
      sourcePlatform: searchData.parsedData.source_platform,
      url: searchData.url,
      isPluginOpen,
      sessionId: searchData.sessionId,
      platform: searchData.metadata.platform,
      indicatorNotFound: searchData.metadata.indicatorNotFound,
      indicatorSelector: searchData.metadata.indicatorSelector,
      parserCategory: searchData.metadata.parserCategory,
      status: searchData.status,
    },
    contacts: [
      {
        contactId,
        fullName: searchData.parsedData.full_name,
        imageLink: searchData.parsedData.imageLink,
        locality: searchData.parsedData.locality,
        topCompany: searchData.parsedData.top_company,
        experienceParsed: searchData.parsedData.experience_parsed,
        organizations: searchData.parsedData.organizations.map(mapOrganization),
        headline: searchData.parsedData.headline,
        linkedinHeaderCompany: searchData.parsedData.linkedinHeaderCompany,
        linkedinHeaderJobTitle: searchData.parsedData.linkedinHeaderJobTitle,
        socialLink: searchData.parsedData.link,
        linkedinKey: searchData.parsedData.linkedinCanonicalId,
      },
    ],
  };
}

export function mapBulkSearchData(searchData, isPluginOpen) {
  return {
    metadata: {
      searchType: BULK_SEARCH_TYPE,
      requestId: uuid(),
      parserType: searchData.metadata.parserType,
      isUnifiedParser: searchData.metadata.isUnifiedParser,
      isUnifiedParserEnabled: searchData.metadata.isUnifiedParserEnabled,
      sourcePlatform: searchData.source_platform,
      url: searchData.url,
      isPluginOpen,
      sessionId: searchData.sessionId,
      platform: searchData.metadata.platform,
      indicatorNotFound: searchData.metadata.indicatorNotFound,
      indicatorSelector: searchData.metadata.indicatorSelector,
      parserCategory: searchData.metadata.parserCategory,
      contactsOnPage: searchData.metadata.contactsOnPage,
      contactsParsed: searchData.metadata.contactsParsed,
    },
    contacts: searchData.contacts.map(contact => {
      const contactId = uuid();

      return ({
        contactId,
        fullName: contact.fullName,
        imageLink: contact.imageLink,
        locality: contact.geoRegion,
        socialLink: contact.socialLink,
        organizations: contact.currentPositions.map(mapCurrentPosition),
        headline: contact.headline,
        linkedinHeaderCompany: contact.linkedinHeaderCompany,
        linkedinHeaderJobTitle: contact.linkedinHeaderJobTitle,
        linkedinKey: contact.linkedinCanonicalId,
      });
    }),
  };
}
